/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Table } from 'antd';

function DataTable({ ...props }) {
  return <Table locale={{ emptyText: 'Không có dữ liệu' }} {...props} />;
}

export default DataTable;
